import { useEffect, useState } from 'react';

export const useAutoSave = (saveFunction, hasUnsavedChanges, currentData, interval = 30000) => {
  const [lastSaved, setLastSaved] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(async () => {
      if (hasUnsavedChanges && !isSaving) {
        setIsSaving(true);
        try {
          await saveFunction(currentData);
          setLastSaved(new Date());
        } catch (error) {
          console.error('Auto-save failed:', error);
        } finally {
          setIsSaving(false);
        }
      }
    }, interval);

    return () => clearInterval(intervalId);
  }, [hasUnsavedChanges, currentData, saveFunction, interval, isSaving]);

  const triggerSave = async () => {
    if (hasUnsavedChanges && !isSaving) {
      setIsSaving(true);
      try {
        await saveFunction(currentData);
        setLastSaved(new Date());
      } catch (error) {
        console.error('Manual save failed:', error);
        throw error;
      } finally {
        setIsSaving(false);
      }
    }
  };

  return { lastSaved, isSaving, triggerSave };
};
